import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { callLogout } from '../../actions/Auth'
import Footer from './Footer'
import FiscalYear from './FiscalYear'

class Nav extends Component {
  constructor () {
    super()
    this.state = {
      isOpen: false
    }
  }
  Hamburger () {
    if (this.state.isOpen) {
      this.setState({ isOpen: false })
    } else {
      this.setState({ isOpen: true })
    }
  }
  logout () {
    this.Hamburger()
    this.props.callLogout()
  }
  render () {
    const { pathname } = this.props.location
    // const { valid } = this.props.auth
    const bearer = window.localStorage.getItem('it.clubhub.bearer')
    return (
      <div className={(this.state.isOpen) ? 'open' : ''}>
        <div className="hamburger" onClick={() => this.Hamburger()}>
          <div className="menuOne">
            <div className="line line-1"></div>
            <div className="line line-2"></div>
            <div className="line line-3"></div>
          </div>
        </div>
        <nav className={(this.state.isOpen) ? 'open' : ''}>
          <div className="inside-nav">
            {
              bearer === null && (
                <ul>
                  <li><Link to="/" onClick={() => this.Hamburger()} className={'lnk-nav ' + (pathname === '/' ? 'active' : '')}>home</Link></li>
                  <li><Link to="/come-funziona" onClick={() => this.Hamburger()} className={'lnk-nav ' + (pathname === '/come-funziona' ? 'active' : '')}>Come Funziona</Link></li>
                  <li><Link to="/accedi" onClick={() => this.Hamburger()} className={'lnk-nav ' + (pathname === '/accedi' ? 'active' : '')}>accedi</Link></li>
                </ul>
              )
            }
            {
              bearer !== null && (
                <ul>
                  <li className="nav-username">
                    {window.localStorage.getItem('it.clubhub.email')}
                  </li>
                  <li>
                    <FiscalYear />
                  </li>
                  <li><Link to="/dashboard" onClick={() => this.Hamburger()} className={'lnk-nav ' + (pathname === '/dashboard' ? 'active' : '')}><i className="fas fa-tachometer-alt"></i> Dashboard</Link></li>
                  <li><Link to="/presenze" onClick={() => this.Hamburger()} className={'lnk-nav ' + (pathname === '/presenze' ? 'active' : '')}><i className="fas fa-clock"></i> presenze</Link></li>
                  <li><Link to="/ricevute" onClick={() => this.Hamburger()} className={'lnk-nav ' + (pathname === '/ricevute' ? 'active' : '')}><i className="fas fa-file-invoice"></i> ricevute</Link></li>
                  <li><Link to="/anagrafiche" onClick={() => this.Hamburger()} className={'lnk-nav ' + (pathname === '/anagrafiche' ? 'active' : '')}><i className="fas fa-users"></i> anagrafiche</Link></li>
                  <li className="csat"><Link to="/bilancio" onClick={() => this.Hamburger()} className={'lnk-nav ' + (pathname === '/bilancio' ? 'active' : '')}><i className="fas fa-money-bill-wave"></i> bilancio</Link></li>
                  <li><Link to="/associazione" onClick={() => this.Hamburger()} className={'lnk-nav ' + (pathname === '/associazione' ? 'active' : '')}><i className="fas fa-award"></i> Associazione</Link></li>
                  <li><Link to="/istruttori" onClick={() => this.Hamburger()} className={'lnk-nav ' + (pathname === '/istruttori' ? 'active' : '')}><i className="fas fa-gamepad"></i> istruttori</Link></li>
                  <li><Link to="/corsi" onClick={() => this.Hamburger()} className={'lnk-nav ' + (pathname === '/corsi' ? 'active' : '')}><i className="fas fa-chalkboard-teacher"></i> corsi</Link></li>
                  <li className="csat"><Link to="/note" onClick={() => this.Hamburger()} className={'lnk-nav ' + (pathname === '/note' ? 'active' : '')}><i className="fas fa-sticky-note"></i> note</Link></li>
                  <li><button onClick={() => this.logout()} className="lnk-nav"><i className="fas fa-sign-out-alt"></i> Esci</button></li>
                </ul>
              )
            }
            <Footer />
          </div>
        </nav>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { callLogout })(Nav)



// WEBPACK FOOTER //
// ./src/components/Bone/Nav.js